<template>
  <div
    v-animate-in-from-left
    class="flex items-center gap-2"
    :style="`--newnum: ${num}; --newfloat: ${float}; --newthousands: ${thousands}`"
    :data-run="isRunning"
    :class="isRunning === undefined ? 'animate-number-trigger' : 'has-trigger'"
  >
    <span
      class="animate-number"
      :class="{ 'animate-number-float': float && !thousands,
                'animate-number-thousands': thousands && !float,
                'animate-number-float-thousands': thousands && float,
      }"
    />
    <span v-if="unit && unit !== 'none'">
      {{ unit }}
    </span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  number: number
  unit?: string | 'none'
  // if not set, the animation will run when the element is in viewport
  isRunning?: boolean
}>()

const thousands = computed(() => {
  return (~~props.number - (~~props.number % 1000)) / 1000
})

const num = computed(() => {
  return ~~props.number % 1000
})

const float = computed(() => {
  return props.number.toString().split(/[.,]/)?.[1]
})
</script>

<style>
@property --thousands {
  syntax: "<integer>";
  initial-value: 0;
  inherits: true;
}
@property --num {
  syntax: "<integer>";
  initial-value: 0;
  inherits: true;
}
@property --float {
  syntax: "<integer>";
  initial-value: 0;
  inherits: true;
}

.animate-number-trigger {

  view-timeline-name: --subjectReveal;
  animation-timeline: --subjectReveal; /*falback */
  animation-timeline: view();

  animation-name:trigger;
  animation-direction: forwards;
  animation-timing-function: ease-out;
  /* animation-timing-function: cubic-bezier(0, 0.82, 0.98, 0.22); */
  animation-duration: 1ms; /* Firefox requires this to apply the animation */
}

.has-trigger {
  --thousands: 0;
  --num: 0;
  --float: 0;
  }

.has-trigger[data-run="true"] {
  --thousands: var(--newthousands);
  --num: var(--newnum);
  --float: var(--newfloat);
}

@keyframes trigger {
  /* position in viewport */
  from, 5.9% {
    --thousands: 0;
    --num: 0;
    --float: 0;
  }
  6%,to {
    --thousands: var(--newthousands);
    --num: var(--newnum);
    --float: var(--newfloat);
   }
}

.animate-number {
  transition: --num 1.5s cubic-bezier(0, 0, 0, 1), --float 3s cubic-bezier(0, 0, 0, 1), --thousands 1s cubic-bezier(0, 0, 0, 1);
  transition-timing-function: cubic-bezier(0, 0, 0, 1);
  counter-reset: thousands var(--thousands) num var(--num) float var(--float);
}

/* 🥲 */
.animate-number::after {
  content: counter(num);
}
.animate-number-float::after {
  content: counter(num) "," counter(float);
}
.animate-number-float-thousands::after {
  content: counter(thousands) " " counter(num) "," counter(float);
}
.animate-number-thousands::after {
  content: counter(thousands) " " counter(num);
}

/* safari  */
@supports not (animation-timeline: view()) {
  .animate-number {
    --thousands: var(--newthousands);
    --num: var(--newnum);
    --float: var(--newfloat);
  }
}
</style>
